import script from "./Move.vue?vue&type=script&setup=true&lang=js"
export * from "./Move.vue?vue&type=script&setup=true&lang=js"

import "./Move.vue?vue&type=style&index=0&id=452d2ec6&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-452d2ec6"]])

export default __exports__